/** Copy text with Clipboard API fallback for older browsers. */

export async function copyToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();

  try {
    const ok = document.execCommand('copy');
    if (!ok) {
      throw new Error('Copy command failed');
    }
  } finally {
    document.body.removeChild(textarea);
  }
}

/** Whether PNG images can be written to the system clipboard. */
export function canCopyImages() {
  if (!navigator.clipboard?.write || typeof window.ClipboardItem === 'undefined') {
    return false;
  }
  if (typeof window.ClipboardItem.supports === 'function') {
    return window.ClipboardItem.supports('image/png');
  }
  return true;
}

/** Call from inside a click handler: Safari and Firefox require user activation. */
export async function copyImageToClipboard(blob) {
  if (!canCopyImages()) {
    throw new Error('Clipboard images are not supported');
  }
  await navigator.clipboard.write([new window.ClipboardItem({ [blob.type]: blob })]);
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
